export const skillsData = [
  {
    label: 'FRONT END',
    data: [
      {
        skillName: 'HTML',
        percentage: '90',
      },
      {
        skillName: 'CSS',
        percentage: '70',
      },
      {
        skillName: 'JAVASCRIPT',
        percentage: '80',
      },
    ],
  },
  {
    label: 'DATABASES',
    data: [
      {
        skillName: 'SQL',
        percentage: '70',
      },
      {
        skillName: 'NoSQL',
        percentage: '70',
      },
      {
        skillName: 'GraphQL',
        percentage: '70',
      },
    ],
  },
  {
    label: 'BACK END',
    data: [
      {
        skillName: 'NODE',
        percentage: '90',
      },
      {
        skillName: 'EXPRESS',
        percentage: '70',
      },
    ],
  },
]
